export * from './Menu';
export * from './MenuItem';
export * from './Separator';
export * from './GroupHeader';
export * from './childData';
export { MenuProvider } from './MenuProvider';
export { useMenu, useMenuProviderProps, useConfirm, useDescendants, } from './headless/useMenu';
export { useMenuState } from './headless/useMenuState';
if ((window === null || window === void 0 ? void 0 : window.location.hostname.includes('localhost')) ||
    (window === null || window === void 0 ? void 0 : window.location.hostname.includes('staging'))) {
    console.warn('Old Menu is deprecated and will be removed in the future. Please use Menu from @clds/menu instead.');
}
//# sourceMappingURL=index.js.map